module.exports = __webpack_public_path__ + "static/media/buy_button_icon.5c72fea9.svg";